/**
 * The branch cards' timing vocabulary: the beat map every body file times
 * against, and the `animation` shorthand that reads it.
 *
 * Split out of `branch-parts.tsx` so that file exports COMPONENTS only — the
 * same cut `cta-classes.ts` makes for the CTA, and for the same reason: a module
 * mixing components with plain values breaks react-refresh, so an edit to the
 * beat map forces a full reload instead of a hot swap while tuning a ~21s
 * choreography by eye.
 *
 * A leaf. It imports nothing, so both halves of the card set can depend on it
 * without either becoming the other's dependency.
 */

/** Delays, in seconds, relative to the branch's composer appearing. */
export const BEAT = {
  type: 0.45,
  send: 1.45,
  seam: 1.4,
  card: 1.7,
  head: 1.95,
  body: 2.2,
  settle: 3.5,
} as const;

/** `animation` shorthand for a staggered entrance at `at + offset`. */
export function enter(at: number, offset: number, name = 'sxUp', dur = '.5s'): string {
  return `${name} ${dur} cubic-bezier(.34,1.56,.64,1) ${(at + offset).toFixed(2)}s backwards`;
}
